import { useDispatch } from 'react-redux'
import Actions from '../../../../Flux/index.js'
import { orderSlice } from '../../../../Flux/Slice/Order/OrderSlice.js'
import type { IOrder } from '../../../../Model/index.js'
import { canUseSpinOnOrder } from '../../../../Model/index.js'
import { useGetAuthenticatedUser } from '../../../../Flux/Selector/index.js'
import type { BaseModalProps } from '../../../Modal/BaseModal.js'
import { ReportSettingsModal } from '../../../Component/Report/ReportSettingsModal.tsx'
import type { TargetTaxonomyKey } from '../../../../Generated/TargetTaxonomy.ts'

export interface OrderReportModalProps {
  order: IOrder
}

/**
 * Order side of {@link ReportSettingsModal}.
 *
 * The SPIN toggle needs INSIGHT on the order (own or lab-shared) to be offered at all — an order report is
 * per-OTU unless someone explicitly asks.
 */
export const OrderReportModal = ({ isOpen, onClose, order }: OrderReportModalProps & BaseModalProps) => {
  const dispatch = useDispatch()
  const user = useGetAuthenticatedUser()

  return (
    <ReportSettingsModal
      isOpen={isOpen}
      onClose={onClose}
      testId="order-report-modal"
      title="Generate Order Report"
      scope="order"
      redlistDefaultLabel="Order / Organization Default"
      defaultTaxonomy={(order.targetTaxonomy as TargetTaxonomyKey) || null}
      defaultRedlist={order.redlistMode || null}
      spinAccess={canUseSpinOnOrder(order, user)}
      onConfirm={(settings) =>
        dispatch(
          Actions[orderSlice.name].getReportRequest({
            orderId: order.id,
            orderName: order.name,
            settings
          })
        )
      }
    />
  )
}
